import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import 'mapbox-gl/dist/mapbox-gl.css'

function renderErrorOverlay(error) {
  try {
    const root = document.getElementById('root')
    if (!root) return
    root.innerHTML = ''
    const pre = document.createElement('pre')
    pre.style.cssText = 'white-space: pre-wrap; color: #fff; background: rgba(0,0,0,0.88); padding: 16px; position: fixed; top: 0; left: 0; right: 0; z-index: 999999; max-height: 60vh; overflow: auto; font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, "Roboto Mono", "Courier New", monospace;'
    pre.textContent = typeof error === 'string' ? error : (error && error.stack) ? error.stack : JSON.stringify(error, null, 2)
    root.appendChild(pre)
  } catch (e) {
    // Fallback to console if overlay rendering fails
    console.error('Failed to render error overlay', e)
  }
}

try {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
} catch (err) {
  console.error('Render error caught in main.jsx', err)
  renderErrorOverlay(err)
}

// IMPORTANT: log only, do not wipe the app. A stray uncaught error/rejection
// anywhere on the page (including deep inside third-party libraries like
// GrapesJS's own internal rendering code, which can throw non-fatal errors
// without actually leaving the app unusable) used to call
// renderErrorOverlay() here, replacing the entire #root DOM with a full-page
// black error screen — turning isolated, often-recoverable errors into a
// hard app-wide outage. The one case worth a full overlay (the initial React
// root failing to render at all) is already handled by the try/catch around
// ReactDOM.createRoot(...).render() above.
window.addEventListener('error', (ev) => {
  console.error('Global error captured', ev.error || ev.message, ev)
})

window.addEventListener('unhandledrejection', (ev) => {
  console.error('Unhandled rejection', ev.reason || ev)
})